export const appVersion = () => {
  /* eslint-disable-next-line no-undef */
  return APP_VERSION
}
